<template>
  <div>
    <v-flex style="max-width: 676px !important">
      <module-title class="title" :title="adminText('workflowsAll.import_export_c366dd1', 'Import/Export')" />
      <v-flex>
        <v-layout :column="$vuetify.breakpoint.xs" class="cards-container">
          <v-flex class="import-export-card">
            <v-layout column align-center>
              <div class="import-export-image-margins">
                <img src="/assets/import.svg" :alt="adminText('workflowsAll.import_icon_13b6584', 'Import icon')">
              </div>
              <div class="import-export-name">{{ adminText('workflowsAll.import_d6fbc9d', 'Import') }}</div>
              <div class="import-export-description import-export-screen-description-margins">
                {{ adminText('workflowsAll.quickly_import_attendees_and_all_of_their_dat_93109e0', 'Quickly import attendees and all of their data using a CSV template.') }}
              </div>
            </v-layout>
          </v-flex>
          <v-flex class="import-export-card" @click="goTo(routes.theaterOrganizer.exportTheater)">
            <v-layout column align-center>
              <img src="/assets/export.svg" :alt="adminText('workflowsAll.export_icon_1c4dcec', 'export icon')" class="import-export-image-margins">
              <div class="import-export-name">{{ adminText('workflowsAll.export_f3e4fad', 'Export') }}</div>
              <div class="import-export-description import-export-screen-description-margins">
                {{ adminText('workflowsAll.export_a_list_of_your_attendees_or_a_full_set_82345aa', 'Export a list of your attendees or a full set of your event\'s analytics data.') }}
              </div>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-flex>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import ModuleTitle from '@/components/shared/module-title.vue'

export default {
  mixins: [WorkflowDisplay],
  name: 'theater-import-export-container',
  components: { ModuleTitle },
}
</script>

<style scoped></style>
